<template>
  <div v-loading.fullscreen.lock="config.loading.save" element-loading-text="Aguarde enquanto a liberação é concluída...">
    <ed-modal
      :title="'LIBERAR ASO' + title"
      :modal="parent.showLiberacao"
      :loadingSave="config.loading.save"
      :loading="config.loading.content"
      :onSave="asoLiberada ? null : salvar"
      :currentTab="tagConfig"
    >
      <div slot="modal-content">
        <el-tabs type="border-card" v-model="tagConfig" @tab-click="handleClick">
          <el-tab-pane label="Config" name="tab-cadastro">
            <span slot="label"><i class="fa fa-unlock"></i> Liberar ASO</span>

            <div class="aso-alert" v-if="asoLiberada">
              <el-alert
                title="Consulta já liberada"
                :closable="false"
                description="A consulta já está liberada e não pode ser liberada novamente."
                type="success"
                show-icon
              />
            </div>

            <ed-form v-if="!asoLiberada" :data="formData" :config="config" :itens="formItems" :response="response">
              <div slot="form-footer"></div>
            </ed-form>
          </el-tab-pane>

          <el-tab-pane label="Config" name="tab-historico">
            <span slot="label">
              <i :class="'fa fa-history' + (novaLiberacao ? ' faa-flash animated' : '')"></i>
              Histórico de Liberação
            </span>

            <TableView :onSearch="getConsultaLiberacao" :tableHead="tableHead" :tableData="tableData" :loadingTable="config.loading.table" :pagination="pagination" :response="response" disableInputSearch disabledConfigCell disableCheckAll />
          </el-tab-pane>
        </el-tabs>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import TableView from "common/table";
import Rest from "common/rest";
import Fct from "common/fct";
import EdModal from "common/modal";
import EdForm from "common/form";
import FormItems from "../_form/liberacao-aso";

export default {
  name: "empresa",
  components: { TableView, EdModal, EdForm },
  mixins: [Rest, Fct],
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.consulta.id"() {
      this.getConsulta();
      this.getConsultaLiberacao();
    },
    "parent.showLiberacao"() {
      this.getConsulta();
      this.getConsultaLiberacao();
    },
    "formData.aptidao"() {
      this.handleAptidao();
    },
  },
  data() {
    return {
      config: {
        tipo: [53, 185, 189],
        click: {
          exames: _.debounce(this.getExame, 1000),
        },
        list: {
          exames: [],
        },
        loading: {
          save: false,
          table: false,
          content: false,
          exames: false,
        },
        disabled: {
          id_tipo_status: false,
          te_alt: false,
          te_esp: false,
          te_ele: false,
          te_ali: false,
          te_rad_ion: false,
          obs: false,
        },
      },
      formData: {
        id: 0,
        id_tipo_status: 69,
        aptidao: null,
        te_alt: null,
        te_esp: null,
        te_ele: null,
        te_ali: null,
        te_rad_ion: null,
        obs: null,
        senha: null,
        arquivo: null,
        exames: [],
      },
      pagination: {},
      response: {},
      tableHead: [
        {
          key: "data",
          sortable: true,
          width: "120px",
          label: "Data",
        },
        {
          key: "usuario",
          sortable: true,
          label: "Usuário",
        },
        {
          key: "status",
          sortable: true,
          label: "Status",
        },
        {
          key: "aptidao",
          sortable: true,
          show_html: true,
          label: "Aptidão",
        },
        {
          key: "tra_altura",
          sortable: true,
          show_html: true,
          label: "Tra. Altura",
        },
        {
          key: "tra_ec",
          sortable: true,
          show_html: true,
          label: "Tra. Espaço Confinado",
        },
        {
          key: "exames",
          sortable: true,
          label: "Exames Alterados",
        },
        {
          key: "obs",
          sortable: true,
          label: "Obs",
        },
      ],
      tableData: [],
      formItems: [],
      novaLiberacao: false,
      tagConfig: "tab-cadastro",
      title: "",
    };
  },

  created() {},

  mounted: function () {
    this.formItems = FormItems;
  },

  // Computed para verificar se a consulta já está liberada (tipo_status.id === 66)
  computed: {
    asoLiberada() {
      return (
        this.parent &&
        this.parent.consulta &&
        this.parent.consulta.tipo_status &&
        this.parent.consulta.tipo_status.id === 66
      );
    },
  },

  methods: {
    handleClick(tab, event) {
      this.novaLiberacao = false;
    },

    handleAptidao() {
      this.config.disabled.id_tipo_status = this.formData.aptidao == "2" || this.formData.aptidao == "5";
      this.config.disabled.te_alt = this.formData.aptidao == "5";
      this.config.disabled.te_esp = this.formData.aptidao == "5";
      this.config.disabled.te_ele = this.formData.aptidao == "5";
      this.config.disabled.te_ali = this.formData.aptidao == "5";
      this.config.disabled.te_rad_ion = this.formData.aptidao == "5";

      if (this.formData.aptidao == "1") {
        this.formData.id_tipo_status = 66;
      } else if (this.formData.aptidao == "2") {
        this.formData.id_tipo_status = 67;
      } else if (this.formData.aptidao == "5") {
        this.formData.id_tipo_status = 70;
      }
    },

    getExame() {},

    getConsulta: function () {
      if (!this.parent.consulta) return;

      this.config.loading.content = true;
      this.config.list.exames = [];

      this.get("empresa/consulta/" + this.parent.consulta.id_con).then((result) => {
        result = result[0];
        this.config.loading.content = false;

        if (result.status == 200) {
          this.formData = {
            id_tipo_status: result.data.tipo_status ? result.data.tipo_status.id : null,
            aptidao: this.toString(result.data.aptidao) == "0" ? null : this.toString(result.data.aptidao),
            te_alt: this.toString(result.data.te_alt) == "0" ? null : this.toString(result.data.te_alt),
            te_esp: this.toString(result.data.te_esp) == "0" ? null : this.toString(result.data.te_esp),
            te_ele: this.toString(result.data.te_ele) == "0" ? null : this.toString(result.data.te_ele),
            te_ali: this.toString(result.data.te_ali) == "0" ? null : this.toString(result.data.te_ali),
            te_rad_ion: this.toString(result.data.te_rad_ion) == "0" ? null : this.toString(result.data.te_rad_ion),
            obs: result.data.obs,
            exames: [],
            senha: null,
          };

          for (let i = 0; i < result.data.exames.length; i++) {
            const element = result.data.exames[i];

            if (element.dem == 0) {
              this.config.list.exames.push(element.exame);
            }
          }
        }
      });
    },

    getConsultaLiberacao: function (_search, _page, _pagination) {
      if (!this.parent.consulta) return;

      this.config.loading.table = true;
      this.tagConfig = "tab-cadastro";
      this.title = " Nº " + this.parent.consulta.id_con + " - " + this.parent.consulta.empresa.nome + " - " + this.parent.consulta.funcionario.nome;

      this.get("empresa/consulta/liberacao/" + this.parent.consulta.id_con, { search: _search, page: _page, pagination: _pagination }).then((result) => {
        result = result[0];

        if (result.status == 200) {
          this.formataData(result);
        }
      });
    },

    formataData: function (result) {
      var data = result.data.data,
        tableData = [],
        self = this,
        pagination = result.data;

      for (var i = 0; i < data.length; i++) {
        var aptidao = "",
          altura = "",
          espaco = "";

        if (data[i].aptidao == "1") aptidao = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO PARA A FUNÇÃO"/>';
        else if (data[i].aptidao == "2") aptidao = '<i class="fa fa-exclamation-triangle fa-2x" style="color:orange" title="APTO COM RESTRIÇÕES"/>';
        else if (data[i].aptidao == "5" || data[i].aptidao == "6") aptidao = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO PARA A FUNÇÃO"/>';

        if (data[i].te_alt == "1") altura = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
        else if (data[i].te_alt == "2") altura = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
        else if (data[i].te_alt == "3") altura = '<i title="N/A">-</i>';

        if (data[i].te_esp == "1") espaco = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
        else if (data[i].te_esp == "2") espaco = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
        else if (data[i].te_esp == "3") espaco = '<i title="N/A">-</i>';

        if (data[i].te_ele == "1") espaco = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
        else if (data[i].te_ele == "2") espaco = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
        else if (data[i].te_ele == "3") espaco = '<i title="N/A">-</i>';

        if (data[i].te_ali == "1") espaco = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
        else if (data[i].te_ali == "2") espaco = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
        else if (data[i].te_ali == "3") espaco = '<i title="N/A">-</i>';

        if (data[i].te_rad_ion == "1") espaco = '<i class="fa fa-thumbs-o-up fa-2x" style="color:green" title="APTO"/>';
        else if (data[i].te_rad_ion == "2") espaco = '<i class="fa fa-thumbs-o-down fa-2x" style="color:red" title="INAPTO"/>';
        else if (data[i].te_rad_ion == "3") espaco = '<i title="N/A">-</i>';

        var item = {
          data: this.toDate(data[i].created, false),
          usuario: data[i].usuario ? data[i].usuario.usuario : null,
          status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
          aptidao: aptidao,
          tra_altura: altura,
          tra_ec: espaco,
          exames: data[i].exame_alt ? data[i].exame_alt.join(", ") : "",
          obs: data[i].obs,
          _data: data[i],
          options: {},
          buttons: [],
        };

        tableData.push(item);
      }

      this.pagination = pagination;
      this.tableData = tableData;
      this.config.loading.table = false;
    },

    salvar: function () {
      this.$confirm(
        "Ao inserir uma NOVA LIBERAÇÃO não será possível desfazer a ação. Deseja prosseguir?",
        "Atenção",
        {
          type: "warning",
        }
      ).then(() => {
        this.config.loading.save = true;
        this.response = {};

        this.post(
          "empresa/consulta/liberacao/" + this.parent.consulta.id_con + "/cadastrar",
          this.formData
        ).then((result) => {
          result = result[0];
          this.response = result;

          this.config.loading.save = false;

          if (result.status == 200) {
            this.edMsg("Liberação cadastrado com sucesso!");

            this.novaLiberacao = true;
            this.tagConfig = "tab-historico";

            this.formataData(result);
            this.getConsulta();
            this.parent.getConsulta();

          }
        });
      });
    },

  },
};
</script>

<style scoped>
.aso-alert {
  display: flex;
  justify-content: center; /* centraliza o bloco do alert horizontalmente */
  align-items: center; /* centraliza verticalmente */
  min-height: 120px; /* garante espaço para centralização vertical */
  margin: 12px 0;
}
.aso-alert .el-alert {
  width: 100%;
  max-width: 820px; /* limita largura para não ocupar toda a modal */
}
.aso-alert .el-alert__title {
  font-size: 28px; /* aumenta o título */
  font-weight: 700;
  text-align: center; /* centra o texto do título */
}
.aso-alert .el-alert__description {
  font-size: 18px; /* aumenta a descrição */
  text-align: center; /* centra o texto da descrição */
}
</style>



// WEBPACK FOOTER //
// liberar-aso.vue?20f090f3